/** Presentacion de los tableros del auditor y del administrador. Solo formato y textos; ningun calculo de negocio. */
import { STAGE_LABELS, STAGE_TONES, stageOf, type StepTone } from './activityStepper';
import type { AuditorDashboardData } from './queries';

/** "5 h" / "3 días" (una duracion, a diferencia de `ageLabel`, que dice "hace ..."). */
export function durationLabel(hours: number | null | undefined): string {
  if (hours === null || hours === undefined) return '—';
  const h = Math.max(0, Math.round(hours));
  return h < 48 ? `${h} h` : `${Math.round(h / 24)} días`;
}

export function pctLabel(n: number | null | undefined): string {
  return n === null || n === undefined ? '—' : `${n}%`;
}

/** Ancho (0-100) de una barra respecto del maximo de la serie; una barra con valor nunca desaparece (min 3). */
export function barWidth(value: number, max: number): number {
  if (max <= 0 || value <= 0) return 0;
  return Math.max(3, Math.round((100 / max) * value));
}

/**
 * Actividades por hito del flujo (Borrador / En revision / Observado-Corregido / Aprobado / Cerrado): los mismos 5 hitos
 * del <ActivityStepper/>, para que el tablero y la ficha de la actividad hablen igual. Siempre devuelve los 5 (con 0),
 * y un estado que el mapa no conozca se ignora en vez de contarse en el hito equivocado.
 */
export function stageCounts(byStatus: Record<string, number>): Array<{ etapa: string; n: number; tone: StepTone }> {
  const n = STAGE_LABELS.map(() => 0);
  for (const [status, count] of Object.entries(byStatus)) {
    const i = stageOf(status);
    if (i !== undefined) n[i] += count;
  }
  return STAGE_LABELS.map((etapa, i) => ({ etapa, n: n[i], tone: STAGE_TONES[i] }));
}

type Controles = AuditorDashboardData['controles_detectivos'];

/**
 * Los tres controles detectivos y QUE mide cada uno exactamente (espejo de auditorDashboard en el backend).
 * `severe`: cualquier valor > 0 merece atencion; los demas son una senal, no una falta.
 */
export const CONTROLES_DETECTIVOS: Array<{ key: keyof Controles; label: string; hint: string; severe: boolean }> = [
  {
    key: 'aprobadas_sin_transicion',
    label: 'Aprobadas sin registro de aprobación',
    hint: 'Actividades en estado Aprobada o Cerrada que no tienen la transición a Aprobada en su historial.',
    severe: true,
  },
  {
    key: 'autoaprobaciones_90d',
    label: 'Autoaprobaciones (90 días)',
    hint: 'Aprobaciones hechas por la misma persona que envió la actividad a revisión.',
    severe: true,
  },
  {
    key: 'cambios_fuera_de_horario_30d',
    label: 'Cambios fuera de horario (30 días)',
    hint: 'Cambios de estado en fin de semana o fuera del horario laboral.',
    severe: false,
  },
];
